// import { ADMIN_PREFIX_PATH } from 'config'
import React, { FC, useContext, useMemo } from 'react'
// import { useParams } from 'react-router'
import { FCC } from 'types'

// Minimal lead contact info needed by timeline empty-state actions
export type TLeadContact = {
 name?: string
 email?: string
 phone?: string
}

type LeadProviderType = {
 leadId?: any
 //  route?: string
 from?: 'lead' | 'other'
 isTransferred?: boolean
 realtorId?: number
 lead?: TLeadContact
 // Opens the page-level Smart Call modal for this lead
 onCall?: () => void
}

export const LeadDetailsContext = React.createContext<LeadProviderType>({})

const LeadDetailsProvider: FCC<LeadProviderType> = ({
 children,
 from,
 leadId,
 isTransferred,
 realtorId,
 lead,
 onCall,
}) => {
 const { Provider } = LeadDetailsContext

 return (
  <Provider
   value={{
    leadId,
    // route,
    from,
    isTransferred,
    realtorId,
    lead,
    onCall,
   }}
  >
   {children}
  </Provider>
 )
}

export default LeadDetailsProvider

export const useLeadDetails = () => useContext(LeadDetailsContext)
